module.exports = __webpack_public_path__ + "static/GlitchlessSonyax44-d62a568aa2ae3b77715401878bec12ec.png";